import {
  FETCH_TEAMS,
  FETCH_TEAM,
  UPDATE_TEAM,
  CREATE_TEAM,
  DELETE_TEAM,
  TEAMS_FILTER_SET,
  TEAMS_PAGE_SET,
  CURRENT_TEAM_RESET
} from '../../constants/Constants';

export const fetchTeams = (pagination, filter, additionalQuery) => ({ 
  type: FETCH_TEAMS.REQUESTED, 
  payload: { pagination, filter, additionalQuery } 
});

export const fetchTeam = (teamId) => ({ type: FETCH_TEAM.REQUESTED, payload: { teamId } });

export const updateTeam = (data) => ({ type: UPDATE_TEAM.REQUESTED, payload: { data } });

export const createTeam = (data) => ({ type: CREATE_TEAM.REQUESTED, payload: { data } });

export const deleteTeam = (teamId) => ({ type: DELETE_TEAM.REQUESTED, payload: { teamId } });

export const setTeamsFilter = (filter) => ({ type: TEAMS_FILTER_SET, payload: filter });

export const setTeamsPage = (page) => ({ type: TEAMS_PAGE_SET, payload: { page } });

export const resetCurrentTeam = () => ({ type: CURRENT_TEAM_RESET }); 


// WEBPACK FOOTER //
// ./src/actions/entities/TeamsActions.js